import { Switch } from '@/utils/switch';
import { SxProps, Theme } from '@mui/material';

export const buttonCommonSX = ({
	variant,
	size,
	underline,
	color,
	disabled,
}: {
	variant?: string;
	size?: string;
	underline?: string;
	color?: string;
	disabled?: boolean;
}): SxProps<Theme> => ({
	...Switch(variant)
		.case('text', () => ({
			fontSize: Switch(size)
				.case('small', () => '13px')
				.case('default', () => '14px')
				.case('medium', () => '15px')
				.case('large', () => '16px')
				.defaultTo(() => '15px'),
			color: Switch(color)
				.case('default', () => '#2C2C2C')
				.defaultTo(() => 'primary.main'),
			...Switch(underline)
				.case('hover', () => ({
					textDecoration: 'none',
					'&:hover': {
						textDecoration: 'underline',
					},
				}))
				.case('always', () => ({
					textDecoration: 'underline',
				}))
				.defaultTo(() => ({
					textDecoration: 'none',
					'&:hover': {
						color: 'primary.dark',
					},
				})),

			...(disabled
				? {
						backgroundColor: 'transparent !important',
						color: 'rgb(119, 74, 145) !important',
						cursor: 'not-allowed !important',
						'&:hover': {
							backgroundColor: 'transparent !important',
							color: 'rgb(119, 74, 145) !important',
						},
				  }
				: {}),
		}))
		.defaultTo(() => ({
			padding: Switch(size)
				.case('small', () => '8px 4px')
				.defaultTo(() => '0px 10px'),
			height: Switch(size)
				.case('small', () => 'auto')
				.defaultTo(() => '44px'),
			borderRadius: '50px',
			fontSize: Switch(size)
				.case('small', () => '13px')
				.defaultTo(() => '15px'),
			fontWeight: 'bold',
		})),
	...{
		...Switch(variant)
			.case('outlined', () => ({
				background: 'transparent',
				border: '1px solid',
				borderColor: 'primary.main',
				color: 'primary.main',
				'&.Mui-disabled': {
					borderColor: 'gray',
					color: 'gray',
					backgroundColor: 'transparent',
					cursor: 'not-allowed',
				},
				'&:hover': {
					backgroundColor: (theme: Theme) =>
						theme.palette.mode === 'dark'
							? `rgba(${theme.palette.primary.main}, 0.1)`
							: `${theme.palette.primary.main}1A`, // 1A es hexadecimal para ~10% de opacidad
					border: '1px solid',
					borderColor: 'primary.main',
					color: 'primary.main',
				},
			}))
			.case('unfocused', () => ({
				background: '#F1F1F1',
				color: '#2C2C2C',
				'&:hover': {
					background: '#E5E5E5',
					color: '#2C2C2C',
				},
			}))
			.defaultTo(() => ({
				'&.Mui-disabled': {
					backgroundColor: 'gray',
					color: '#ffffff',
					opacity: 0.5,
				},
			})),
	},
});
